module.exports = __webpack_public_path__ + "img/6_16ebfe891.png";